import PropTypes from 'prop-types'
import MultiClamp from 'react-multi-clamp'
import { Badge as ShippingBadge } from '@leroy-merlin-br/backyard-react-ui'

import { dataLayer } from 'reactSite/Cart/services'

import { FormatPrice, PrefixPrice } from 'reactUtils/Price'

import Badge from 'checkout/components/CrossServices/Installation/Icons/Badge'
import { default as QuantityButton } from 'checkout/containers/ProductQuantity'
import { isServicesEnabled } from 'checkout/modules/feature'

import * as S from './styled'

const ProductDetails = ({
  regionId,
  type,
  removeProduct,
  isMobile,
  updateProduct,
  services = [],
  availableServices = [],
  ...product
}) => {
  const {
    brand,
    categoryTree,
    id,
    name,
    packaging,
    packagingCount,
    price: { from: priceFrom, to: priceTo, total: priceTotal },
    productUrl,
    quantity,
    productId,
    skuId,
    shopName,
    storeId,
    translatedUnit
  } = product

  const hasService = availableServices.find(service => service.productId === productId)

  const removeServiceFromDataLayer = () => {
    const service = services.find(item => item.relatedProduct.productId === productId)

    if (service) {
      dataLayer.removeService({
        regionId,
        serviceId: service.serviceId,
        serviceName: service.name,
        price: service.price,
        quantity: service.quantity,
        category: service.serviceBankName
      })
    }
  }

  return (
    <S.ProductDetails>
      <S.Header>
        <S.AnchorTitle href={productUrl} title={name}>
          <MultiClamp ellipsis="..." clamp={isMobile ? 2 : 1} itemProp="name">
            {name}
          </MultiClamp>
        </S.AnchorTitle>

        <S.DeleteIcon
          className="glyph glyph-trash-can"
          onClick={() => {
            removeProduct({ ...product, regionId })
            removeServiceFromDataLayer()
          }} />
      </S.Header>

      <S.Content>
        <div>
          {priceFrom && priceFrom !== priceTo && (
            <S.Price as="span" size="kilo" decoration="strike" align="left">
              <FormatPrice quantity={packaging} unit={translatedUnit} price={priceFrom} />
            </S.Price>
          )}
          {priceTo &&
            <S.Price as="span" size="kilo" align="left">
              <PrefixPrice packaging={packaging} packagingCount={1} />
              <FormatPrice quantity={packaging} unit={translatedUnit} price={priceTo} />
            </S.Price>
          }
          <S.PriceTotal as="span" bold size="mega">
            <PrefixPrice packaging={packaging} packagingCount={packagingCount} />
            <FormatPrice quantity={quantity} unit={translatedUnit} price={priceTotal} />
          </S.PriceTotal>
        </div>
      </S.Content>
      <S.Footer>
        <QuantityButton
          brand={brand}
          name={name}
          categoryTree={categoryTree}
          id={id}
          productId={productId}
          regionId={regionId}
          type={type}
          shopName={shopName}
          quantity={quantity}
          packaging={packaging}
          packagingCount={packagingCount}
          skuId={skuId}
          storeId={storeId}
          price={{ to: priceTo }}
          updateProduct={updateProduct}
        />
        <div>
          { isServicesEnabled && hasService && <Badge width="100" /> }
          <S.ShippingWrapper>
            <ShippingBadge isLight color="yellow">
              {type === 'delivery' ? 'Entregar' : 'Retirar'}
            </ShippingBadge>
          </S.ShippingWrapper>
        </div>

      </S.Footer>
    </S.ProductDetails>
  )
}

ProductDetails.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      productUrl: PropTypes.string,
      packaging: PropTypes.number,
      unit: PropTypes.string,
      price: PropTypes.shape({
        from: PropTypes.number,
        to: PropTypes.number,
        total: PropTypes.number
      }),
      quantity: PropTypes.number
    })
  )
}

export default ProductDetails
